import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const PublisherConvertedFileValidationReport: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_ASA_API}/get-file-content`),
};

export default PublisherConvertedFileValidationReport;
